<!-- Form -->
@if (form) {
  <medsurf-design-form-control-form
    [formGroup]="form"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2">
      <!-- Label -->
      <medsurf-editor [formField]="false"
        [control]="form.controls.content"
        label="global.question_text"
        placeholder="global.question_text"
      (valueChange)="onSubmit()"></medsurf-editor>
      <!-- Solution Text -->
      <medsurf-editor [formField]="false"
        [control]="form.controls.solutionText"
        label="global.answer"
        placeholder="global.answer"
      (valueChange)="onSubmit()"></medsurf-editor>
      <!-- Explanation -->
      <medsurf-editor [formField]="false"
        [control]="form.controls.explanation"
        label="global.explanation_text"
        placeholder="global.explanation_text_description"
      (valueChange)="onSubmit()"></medsurf-editor>
    </div>
  </medsurf-design-form-control-form>
}
